<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                <translate v-if="clientAddress">Adresse bearbeiten</translate>
                <translate v-if="!clientAddress">Adresse hinzufügen</translate>
            </modal-header>
            <modal-content>
                <h5>
                    <translate>Unternehmen</translate>
                </h5>
                <form-input id="company" :label="this.$gettext('Firma')" name="company" v-model="form.company"
                            :error="form.errors.company"/>



                <form-group>
                    <form-input id="street" :label="this.$gettext('Straße')" name="street" v-model="form.street"
                                :error="form.errors.street" class="two-three" />
                    <form-input id="street_no" :label="this.$gettext('Nummer')" name="street_no" v-model="form.street_no"
                                :error="form.errors.street_no" class="one-three" />
                </form-group>

                <form-group>
                    <form-input id="zip" :label="this.$gettext('PLZ')" name="zip" v-model="form.zip"
                                :error="form.errors.zip" class="one-three" />
                    <form-input id="city" :label="this.$gettext('Ort')" name="city" v-model="form.city"
                                :error="form.errors.city" class="two-three" />
                </form-group>

                <form-select id="client_country_id" :label="this.$gettext('Land')" name="client_country_id"
                             v-model="form.client_country_id" :error="form.errors.client_country_id"
                             :options="clientCountryOptions"/>
                <hr>
                <h5>
                    <translate>Kontakt</translate>
                </h5>
                <form-group>
                    <form-input id="name" :label="this.$gettext('Name')" name="name" v-model="form.name"
                                :error="form.errors.name"/>

                    <form-input id="street_additional" :label="this.$gettext('Abteilung (optional)')" name="street_additional" v-model="form.street_additional"
                                :error="form.errors.street_additional" />
                </form-group>
                <form-group>
                    <form-input id="phone" :label="this.$gettext('Telefon (optional)')" name="phone" v-model="form.phone"
                                :error="form.errors.phone" />

                    <form-input id="mobile" :label="this.$gettext('Mobil (optional)')" name="mobile" v-model="form.mobile"
                                :error="form.errors.mobile" />
                </form-group>
                <form-group>
                    <form-input id="fax" :label="this.$gettext('Fax (optional)')" name="fax" v-model="form.fax"
                                :error="form.errors.fax" class="one-half"/>
                    <div style="flex: 1 1 50%;"></div>
                </form-group>
                <form-checkbox id="default_address" :option="this.$gettext('Standard Adresse')" v-model:checked="form.default_address"  />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                    <translate>Speichern</translate>
                </form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';

export default {
    name: 'AddressModal',
    components: {
        FormCheckbox,
        FormGroup,
        FormSelect, FormInput, FormButton, ModalActions, ModalContent, ModalHeader, Modal
    },
    emit: ['closeDialog'],
    props: {
        clientAddress: Object,
        clientCountries: Object,
    },
    data() {
        const form = useForm({
            default_address: this.clientAddress?.default_address,
            company: this.clientAddress?.company,
            name: this.clientAddress?.name,
            street: this.clientAddress?.street,
            street_no: this.clientAddress?.street_no,
            street_additional: this.clientAddress?.street_additional,
            zip: this.clientAddress?.zip,
            city: this.clientAddress?.city,
            client_country_id: this.clientAddress?.client_country_id,
            phone: this.clientAddress?.phone,
            mobile: this.clientAddress?.mobile,
            fax: this.clientAddress?.fax,
        });

        return {form};
    },
    computed: {
        clientCountryOptions() {
            return this.clientCountries;
        }
    },
    methods: {
        submit() {
            if (this.clientAddress) {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .patch(this.$$route('address.patch', {'clientAddress': this.clientAddress.id}), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .post(this.$$route('address.post'), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            }

        },
    },
};
</script>
